import { render, staticRenderFns } from "./CreditTradeAccounts.vue?vue&type=template&id=2b0d437c&scoped=true&"
import script from "./CreditTradeAccounts.vue?vue&type=script&lang=js&"
export * from "./CreditTradeAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0d437c",
  null
  
)

export default component.exports